<template>
  <md-dialog :md-active.sync="isShowWorkerCommentDialog" :md-close-on-esc="false" :md-click-outside-to-close="false">
    <md-dialog-title>本文</md-dialog-title>
    <md-dialog-content>
      <div class="form-group">
        <textarea :value=workerComment class="form-control" id="worker-comment" rows="5"></textarea>
      </div>
    </md-dialog-content>
    <md-dialog-actions class="md-layout md-alignment-top-center md-gutter">
      <div class="md-layout-item md-size-45" v-if="isShowCancelBtn">
        <button class="btn btn-outline-dark btn-block" @click="cancel">キャンセル</button>
      </div>
      <div class="md-layout-item" :class="{ isShowCancelBtn: 'md-size-45' }">
        <button class="btn btn-primary btn-block" @click="close">{{btnTitle}}</button>
      </div>
    </md-dialog-actions>
  </md-dialog>
</template>


<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'MemoDialog',
    props: {
      isShowWorkerCommentDialog: {
        type: Boolean,
        default: false,
      },
      btnTitle: String,
      isShowCancelBtn: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      ...mapGetters([
        'workerComment',
      ]),
    },
    methods: {
      cancel() {
        this.$emit('cancel');
      },
       close() {
        this.$emit('close', document.getElementById('worker-comment').value);
      },
    },
  };
</script>
<style scoped>
  .md-dialog {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/globals/WorkerCommentDialog.vue?93b68d08